import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import type { ContentReference, View } from '@ilteducation/content-collections-types';
import type {
  CollectionsByIdsSelectorConfig,
  CollectionsSelectorConfig,
} from '@ilteducation/content-collections-types/services/collections-selectors/config';

type Props = {
  id: string;
  title: string;
  item: View;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'Show',
  props: {
    id: null,
    title: null,
    item: null
  },
  setup(__props: any) {

const props = __props as {
  id: string;
  title: string;
  item: View;
}


const getCoverUrl = (content: ContentReference) => {
  if (content.type === 'Book') {
    const cfUrl = process.env.VUE_APP_COVERS_DOMAIN;
    return `https://${cfUrl}/bookCovers/${content.id}/cover.png?width=128`;
  }
  return null;
};

function isCollById(sel: CollectionsSelectorConfig): sel is CollectionsByIdsSelectorConfig {
  return sel.type === 'CollectionsByIds';
}

const getSelectorSect = (sel: CollectionsSelectorConfig): { id: string; name: string }[] => {
  if (isCollById(sel)) {
    return sel.ids.map((id) => ({ id: '1', name: id }));
  }
  return [{ id: '123', name: sel.type }];
};

let id = 0;
const treeData = props.item.sections.map((section) => ({
  // eslint-disable-next-line no-plusplus
  id: ++id,
  name: 'Section',
  // eslint-disable-next-line no-plusplus
  children: section.selectors.map((sel) => ({ id: ++id, name: sel.type, children: getSelectorSect(sel) })),
}));

return { __sfc: true,props, getCoverUrl, isCollById, getSelectorSect, id, treeData }
}

})